import {useEffect} from 'react'
import {UnitEditModalHeader} from './UnitEditModalHeader'
import {UnitEditModalFormWrapper} from './UnitEditModalFormWrapper'

const UnitEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_unit'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-850px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <UnitEditModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 px-2 mx-xl-5 '>
              <UnitEditModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {UnitEditModal}
